import { createAsyncThunk } from '@reduxjs/toolkit';
import { Server, identityClient } from '@wajeez-web/core/api-base';
import { ApiMethod } from '@wajeez-web/stores/base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';

import { AlertInput } from '../types';

export const name = 'userSummaries';

export const uploadUserSummary: ApiMethod<
  Server.UploadUserSummaryInput & AlertInput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_UserSummaries_Client(
      undefined,
      identityClient
    );

    const response = await client.userSummaries_post_V1(data);

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = { ...error.response }.data;

    dispatch(
      CommonActions.setAlert({
        for: data.alert?.for,
        show: true,
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(errors);
  }
};

export const uploadUserSummaryAsync = createAsyncThunk(
  name + '/uploadUserSummary',
  uploadUserSummary
);
